module.exports = __webpack_public_path__ + "static/contact_tracteur-ee490f09ed295c5e50d64c402f6d1a6f.jpg";